module.exports = __webpack_public_path__ + "static/head-with-lines-657816316cf87bb9450694cd91fbb79b.png";